import { ControlPointRounded } from '@mui/icons-material'
import { Button } from '@mui/material'
import React, { useContext, useRef } from 'react'
import makeStyles from '@mui/styles/makeStyles'
import SessionFormDialog from '../session-form-dialog'
import { useEvent } from '@emerald-works/react-event-bus-client'
import { SkillBiteEditSlice } from '../../../../../reducers'
import { BannerStatic } from '../../../../../components'
import { useSelector } from 'react-redux'
import { BuildNavigationContext } from '../..'

const useStyles = makeStyles(({ palette }) => ({
  addSessionButton: {
    border: '1px dashed #BCBCBC',
    borderRadius: '10px',
    color: palette.primary.main,
    marginTop: '16px',
    marginBottom: '16px'
  }
}))

const AddSessionDialog = () => {
  const classes = useStyles()
  const modalRef = useRef()
  const skillBite = useSelector(SkillBiteEditSlice.selectors.selectSkillBite)
  const { discardChangesOnNavigationGuard } = useContext(BuildNavigationContext)

  const [addSession] = useEvent([
    SkillBiteEditSlice.eventBus.addSession({
      onSuccess: () => {
        BannerStatic.show({
          label: 'Session added successfully'
        })
        modalRef.current.close()
      },
      onError: (error) => {
        console.log(error)
        BannerStatic.show({
          label: 'Error trying to add session',
          isError: true
        })
        modalRef.current.close()
      }
    })
  ])

  const handleClickOpen = () => {
    discardChangesOnNavigationGuard(() => {
      modalRef.current.open()
    })
  }

  const handleOnSubmit = (data) => {
    addSession.trigger({
      name: data.name,
      description: data.description,
      order: skillBite.sessions.length + 1,
      skillBiteId: skillBite.id
    })
  }

  return (
    <>
      <Button className={classes.addSessionButton} size='large' fullWidth onClick={handleClickOpen}>
        <ControlPointRounded color='primary' sx={{ mr: 1 }} />
        Add Session
      </Button>
      <SessionFormDialog
        ref={modalRef}
        title='New Session'
        isLoading={addSession.isWorking}
        submitText='Add'
        onSubmit={handleOnSubmit}
        session={{}}
      />
    </>
  )
}

export default AddSessionDialog
